import produce from 'immer'
import { handleActions } from 'redux-actions'

import { openModal, closeModal } from './actions'

export const defaultState = {
  type: null,
  props: {},
}

export default handleActions({
  [openModal]: produce((draft, action) => {
    const { type, props } = action.payload
    draft.props = props
    draft.type = type
  }),

  [closeModal]: produce((draft) => {
    draft.props = {}
    draft.type = null
  }),
}, defaultState)
